import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'antd';
import Translate from 'react-translate-component';
import { SendOutlined } from '@ant-design/icons';

import { openModalCreateApplication } from 'actions/modalActions';

export const ApplicationButton = connect(null, { openModalCreateApplication })(
    ({ id, name, openModalCreateApplication }) => (
        <Button disabled={!id} onClick={() => openModalCreateApplication({ id, name })}>
            <SendOutlined />
            <Translate component='span' content={'education.application.create'} />
        </Button>
    )
);
